﻿(function(){
    var currDate = new Date(),
        currYear = currDate.getFullYear();

    $(".copyright #copyright-year").html(currYear);
})();